import { Button, Column, ComboBox, DatePicker, DatePickerInput, FileUploader, FluidForm, Form, FormLabel, Grid, Header, Icon, NumberInput, Row, Select, SelectItem, TextArea, TextInput, Tile, } from "carbon-components-react";
import { Heading, Section } from "carbon-components-react/lib/components/Heading";
import FilterableMultiSelect from "carbon-components-react/lib/components/MultiSelect/FilterableMultiSelect";
import { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Padding from "../../components/Padding";
import UIShell from "../../components/UIShell";
import { createCategory } from "../../redux/actions/categoryAction";
import { Editor } from "@tinymce/tinymce-react";

function SubscriptionsFormPage({ isLoading }) {
  const history = useHistory()
  const dispatch = useDispatch()

  const [formContent, setFormContent] = useState({
    "periode": undefined,
    "price": undefined,
    "features": undefined,
    "hideline": undefined,
  })

  const submitForm = (e) => {
    e.preventDefault()

    dispatch(createCategory(formContent, (_data) => {
      history.push("/subscriptions")
    }))
  }

  return (
    <UIShell breadcrumbs={[
      { name: 'Home', link: "/" },
      { name: 'Subscriptions', link: "/subscriptions" },
      { name: 'Create' }
    ]}>
      <Grid>
        <Row>
          <Column>
            <Tile>
              <Section style={{ margin: '1rem 0 4rem 0' }}>
                <Heading >Create Subscription</Heading>
                <p>Description Create Subscription</p>
              </Section>
              <Form onSubmit={submitForm}>
                <TextInput
                  labelText="Periode"
                  value={formContent.periode}
                  onChange={(v) => setFormContent((_state) => ({
                    ..._state,
                    periode: v.target.value
                  }))}
                  style={{ marginBottom: '2rem' }}
                  light
                />
                <TextInput
                  labelText="Price"
                  value={formContent.price}
                  placeholder='ex. 450'
                  onChange={(v) => setFormContent((_state) => ({
                    ..._state,
                    price: v.target.value
                  }))}
                  style={{ marginBottom: '2rem' }}
                  light
                />
                <TextInput
                  labelText="Hide Line"
                  value={formContent.hideline}
                  onChange={(v) => setFormContent((_state) => ({
                    ..._state,
                    hideline: v.target.value
                  }))}
                  style={{ marginBottom: '2rem' }}
                  light
                />
                {/* <TextArea
                  labelText="Features"
                  value={formContent.answer}
                  onChange={(v) => setFormContent((_state) => ({
                    ..._state,
                    answer: v.target.value
                  }))}
                  light
                  style={{ marginBottom: '2rem' }}
                /> */}
                <Editor
                  apiKey='vr0c20b2k13q7q4r6a7tq03v3i52hdzkmkie3w9xzn9gubev'
                  init={{
                    height: 500,
                    menubar: true,
                    plugins: [
                      'advlist autolink lists link image',
                      'charmap print preview anchor help',
                      'searchreplace visualblocks code',
                      'insertdatetime media table paste wordcount',
                    ],
                    toolbar:
                      'undo redo | formatselect | bold italic | \
									alignleft aligncenter alignright | \
									bullist numlist outdent indent | help',
                  }}
                  onChange={(v) => setFormContent((_state) => ({
                    ..._state,
                    features: v.target.value
                  }))}
                />
                <Padding top="1rem">
                  <Button disabled={isLoading} type="submit" kind="primary">Save</Button>
                  <Button onClick={() => history.push("/subscriptions")} kind="secondary">Cancel</Button>
                </Padding>
              </Form>
            </Tile>
          </Column>

        </Row>
      </Grid>

    </UIShell>
  )
}

const mapStateToProps = state => {
  return {
    isLoading: state.uxReducer.isLoading
  }
}

export default connect(mapStateToProps)(SubscriptionsFormPage)